import {older_generation_cost_adjustment,get_skip_shape_regex} from "./dbcsi_external.js";


function   pick_ec2_shape(regionInfo, config) {
    //based on matchConfig, line 1960
    //based on targetconfig_rds() . line 3360
    
    // **************************
    // EC2 Configuration
    // **************************
    
    // ec2Items = array of different EC2 Shapes to consider
    // config = details about the target values and other properties of the database

    
    
    var ec2Items = regionInfo.shapes;
          //Now work on RDS
          // console.log("pick_rds_shape");
          
          //Step1 - match to ec2Items
          
    var ec2Itemselected = null;
    let closeness = -999;
    let closeness_string = "";
    let match_string = "";

    let gap_memory=  0;
    let gap_throughput=  0;
    let gap_iops=  0;
    let gap_vcpu=  0;
          
    function rdsCompareCost(a, b) {
      // Use toUpperCase() to ignore character casing
          var temp_UseRI = config.UseRI;
           // ignore Savings Plans for Elasticache for now
           if ( (temp_UseRI=="SP-Only") || (temp_UseRI=="RI+SP") || (temp_UseRI=="SP") ) {
             temp_UseRI="RI";
           }
      
      const itemA = older_generation_cost_adjustment(((temp_UseRI=='RI') && a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a) * 10000 + a.VCPU*1;
      const itemB = older_generation_cost_adjustment(((temp_UseRI=='RI') && b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b) * 10000 + b.VCPU*1;

      let comparison = 0;
      if (itemA > itemB) {
        comparison = 1;
      } else if (itemA < itemB) {
        comparison = -1;
      }
      return comparison;
    }

    function rdsCompareVCPU(a, b) {
      // Use toUpperCase() to ignore character casing
          var temp_UseRI = config.UseRI;
           // ignore Savings Plans for Elasticache for now
           if ( (temp_UseRI=="SP-Only") || (temp_UseRI=="RI+SP") || (temp_UseRI=="SP") ) {
             temp_UseRI="RI";
           }
      
      const itemA = a.VCPU * 10000 + older_generation_cost_adjustment(((temp_UseRI=='RI') && a.Linux1yrNURI * 1 > 0 ? a.Linux1yrNURI*1 : a.LinuxOD*1), a);
      const itemB = b.VCPU * 10000 + older_generation_cost_adjustment(((temp_UseRI=='RI') && b.Linux1yrNURI * 1 > 0 ? b.Linux1yrNURI*1 : b.LinuxOD*1), b);

      let comparison = 0;
      if (itemA > itemB) {
        comparison = 1;
      } else if (itemA < itemB) {
        comparison = -1;
      } else if (itemA == itemB) {
        // final sort is by Name in REVERSE order.  This should make r6i.xlarge appear ahead of r5.xlarge
        if (a.Name > b.Name) {
          comparison = -1;
        } else if (a.Name < b.Name) {
          comparison = 1;
        }
      }
      return comparison;
    }
        
    //if optgoal_choice is min_cost, sort by cost, then VCPU.  if optgoal_choice is min_license, sort by VCPU, then cost
    if (config.optgoal_choice=="min_license") {
      ec2Items.sort(rdsCompareVCPU);
      // console.log("sort by VCPU");
    } else  {
      ec2Items.sort(rdsCompareCost);
      // console.log("sort by Cost");
    }  

     // Skip Shape Filter (prefs.rdsSkipShape_preset / rdsSkipShape_expr), shared by the RDS-Oracle, EC2, EC2+FSxN, and Aurora pickers
     var regex = get_skip_shape_regex(config.frozen_prefs);
     let doSkipRegex = (regex !== null);

        
    for (var bii = 0; bii < ec2Items.length; bii++) {
              
          //only process if Linux record
        if (ec2Items[bii].LinuxOD *1 >0) {


          if ( doSkipRegex &&
                regex.test(ec2Items[bii].Name.toLowerCase()) ) {      
                 // console.log("skipping EC2 shape based on regex");
               } 
          else if ( config.frozen_prefs.tshape_algo == "N" &&
                 ec2Items[bii].Name.substring(0, 1) == "t") {
              // console.log("skipping EC2 shape based on t shape");
            }
          else
            {
  
            match_string = `${ec2Items[bii].Name} with ${ec2Items[bii].VCPU} VCPU${((typeof ec2Items[bii].OptimizeVCPUs != "undefined")&&(ec2Items[bii].OptimizeVCPUs != null)&&(ec2Items[bii].OptimizeVCPUs != "None")&& (ec2Items[bii].OptimizeVCPUs != "2")&&(config.optgoal_choice=="Y") ) ? " (OptimizeCPU eligible)" : ""}, ${ec2Items[bii].Memory} GB, ${ec2Items[bii].Throughput} MB/s, ${ec2Items[bii].IOPS} IOPS`;
    
            //TODO: have flag to choose or not choose t* shapes
            if (
              ec2Items[bii].VCPU * 1 >= config.VCPU * 1 &&
              ec2Items[bii].Memory * 1 >= config.Memory * 1 &&
              ec2Items[bii].Throughput * 1 >= config.Throughput * 1 &&
              ec2Items[bii].IOPS * 1 >= config.IOPS * 1
            ) {
    
                //check if we should skip this because it does not support OptimizeCPU
                if ((typeof ec2Items[bii].OptimizeVCPUs != "undefined")&&(ec2Items[bii].OptimizeVCPUs != null)) {
                  ec2Itemselected = ec2Items[bii];
                  // console.log("Submit: found rds match:"+ec2Items[bii].Name)
                  break;
                } else {
                  //this shape does not use optimizeCPU.  are we close?
                  if ((ec2Items[bii].VCPU * 1 - config.VCPU * 1)<5) {
                      //close enough
                      ec2Itemselected = ec2Items[bii];
                      // console.log("Submit: found rds match:"+ec2Items[bii].Name+ " reqVCPU="+config.VCPU + "shapeVCPU="+ec2Items[bii].VCPU)
                      break;
                  }
    
    
                }
            } else {
              //the shape was not selected.
              let new_closeness = Math.min((ec2Items[bii].VCPU * 1 - config.VCPU * 1) / ec2Items[bii].VCPU,0) +
                Math.min((ec2Items[bii].Memory * 1 - config.Memory * 1 ) / ec2Items[bii].Memory,0) +
                Math.min((ec2Items[bii].Throughput * 1 - config.Throughput * 1 ) / ec2Items[bii].Throughput,0) +
                Math.min((ec2Items[bii].IOPS * 1 - config.IOPS * 1) / ec2Items[bii].IOPS,0);
                    
              if (new_closeness > closeness) {
                gap_memory=  Math.max((config.Memory * 1 ) - ec2Items[bii].Memory * 1 ,0);
                gap_throughput=  Math.max((config.Throughput * 1 ) - ec2Items[bii].Throughput * 1 ,0);
                gap_iops=  Math.max((config.IOPS * 1 ) - ec2Items[bii].IOPS * 1 ,0);
                gap_vcpu=  Math.max((config.VCPU * 1 ) - ec2Items[bii].VCPU * 1 ,0);
                 // console.log(ec2Items[bii].Name, new_closeness);
                // console.log("Next closest match:",ec2Items[bii].Name," ",ec2Items[bii].VCPU," ",ec2Items[bii].Memory," ",ec2Items[bii].Throughput," ",ec2Items[bii].IOPS);
                // closeness_string = `Next closest match: ${ec2Items[bii].Name} with ${ec2Items[bii].VCPU} VCPU${( ((typeof ec2Items[bii].OptimizeVCPUs != "undefined")&&(ec2Items[bii].OptimizeVCPUs != null)) && (ec2Items[bii].OptimizeVCPUs != "2") && (config.optgoal_choice=="Y") && (config.UseSE2=="No") && ((ec2Items[bii].VCPU * 1 - config.VCPU * 1)>0)  ) ? " (OptimizeCPU eligible)" : ""}, ${ec2Items[bii].Memory} GB, ${ec2Items[bii].Throughput} MB/s, ${ec2Items[bii].IOPS} IOPS`;
                closeness_string = `Next closest match: ${ec2Items[bii].Name} with ${ec2Items[bii].VCPU} VCPU${(gap_vcpu>0) ? " (short "+gap_vcpu.toFixed(1)+" VCPU)" : ""}${( ((typeof ec2Items[bii].OptimizeVCPUs != "undefined")&&(ec2Items[bii].OptimizeVCPUs != null)&&(ec2Items[bii].OptimizeVCPUs != "None")) && (ec2Items[bii].OptimizeVCPUs != "2") && (config.optgoal_choice=="Y") && (config.UseSE2=="No") && ((ec2Items[bii].VCPU * 1 - config.VCPU * 1)>0)  ) ? " (OptimizeCPU eligible)" : ""}, ${ec2Items[bii].Memory} GB${(gap_memory>0) ? " (short "+gap_memory+" GB)" : ""}, ${ec2Items[bii].Throughput} MB/s${(gap_throughput>0) ? " (short "+gap_throughput+" MB/s)" : ""}, ${ec2Items[bii].IOPS} IOPS${(gap_iops>0) ? " (short "+gap_iops+" IOPS)" : ""}`;
                closeness=new_closeness;
             }
            } //end if selected
          } //end if t shape  
        } // end only process if Linux
      } //end loop
          
    
      // console.log(match_string);
      // console.log("RDS", closeness_string);
      if (ec2Itemselected==null) {
        ec2Itemselected = { Name: null};
      }
      ec2Itemselected.closeness_string = closeness_string;
      ec2Itemselected.match_string = match_string;
      ec2Itemselected.ec2_gap_memory = gap_memory;
      ec2Itemselected.ec2_gap_throughput = gap_throughput;
      ec2Itemselected.ec2_gap_iops = gap_iops;
      ec2Itemselected.ec2_gap_vcpu = gap_vcpu;
      return ec2Itemselected;
    }
    



function   calculate_ec2_config(regionInfo, ec2ItemSelected, config) {
//based on matchConfig, line 1960
//based on targetconfig_rds() . line 3360

// **************************
// EC2 Configuration
// **************************

// ec2ItemSelected = a document contain specific ec2Item (shape) and its details, closeness_string, and match_string
// config = details about the target values and other properties of the database



      if ( (config.VolumeType==undefined) || (config.VolumeType=='') ) {
        if (config.frozen_prefs.ebs_algo=='gp2') config.VolumeType='gp2';
        if (config.frozen_prefs.ebs_algo=='gp3') config.VolumeType='gp3';
        if (config.frozen_prefs.ebs_algo=='io1') config.VolumeType='io1';
        
        if (config.frozen_prefs.ebs_algo=='p-gp') {
          //Prefer gp2 or gp3
            config.VolumeType='gp3'; //default gp3 for now
        }
      }  
      // Step 2 - prepare additional fields describing the configuration 
      
      
            //TODO hard code backup for now
      config.BackupType = 'none';
      config.Backup = '0';
      config.SnapshotDays = '1';


      if ((ec2ItemSelected.Name == null)) {
        // console.log("Submit: No matching EC2 found for "+ config.database);
        
        
        // Step 2a- This is not a fit for EC2, so respond accordingly
        
          
        
        config.iomb_warnings = "Y";
        config.ec2_shape = "N/A";

        
        config.targetconfig_ec2 = {
          summaryText: "DBCSI's current logic is not able to auto-size this configuration for EC2. Please reach out to your AWS Database Specialist for help.",
          monthly_estimate: "null",        
          shape: "null",
          shape_OD: "null",
          shape_RI: "null",
          shape_RI_SE2: "null",
          shape_max_vcpu: "null",
          shape_optimize_vcpu: "null",
          requested_vcpu: "null",
          shape_memory: "null",
          requested_memory: "null",
          shape_throughput: "null",
          requested_throughput: "null",
          shape_summaryText: "",
          ebs_data_type: "null",
          ebs_data_size: "null",
          ebs_data_iops: "",
          ebs_data_summaryText1: "",
          ebs_data_summaryText2: "",
          backup_style: "null",
          ebs_backup_type: "null",
          ebs_backup_size: "null",
          ebs_backup_iops: "",
          ebs_backup_snap_size: "",
          ebs_backup_summaryText1: "",
          ebs_backup_summaryText2: "",
          license_summaryText: "",
          comments: "",
          warnings: "No matching shape found",
          iops_warnings: "",
          UseMAZ: "No",
          UseSE2: "No",
          closeness_string: ec2ItemSelected.closeness_string,
          match_string: ""
        };
        

      } else
      {


        // Step 2b - This is a fit for EC2.  So, describe it
        
        
        // this is the old targetconfig_rds code...
      var tempConfig = {
        summaryText: "Select an EC2 Shape to continue...",
        monthly_estimate: "null",
        shape: "null",
        shape_OD: "null",
        shape_RI: "null",
        shape_RI_SE2: "null",
        shape_max_vcpu: "null",
        shape_optimize_vcpu: "null",
        requested_vcpu: "null",
        shape_memory: "null",
        requested_memory: "null",
        shape_throughput: "null",
        requested_throughput: "null",
        shape_baselinethroughput: "null",    
        shape_baselineIOPS: "null",        
        shape_IOPS: "null",        
        shape_summaryText: "",
        shape_cost: "",
        ebs_data_type: "null",
        ebs_data_size: "null",
        ebs_data_iops: "",
        ebs_data_summaryText1: "",
        ebs_data_summaryText2: "",
        ebs_data_cost: "",
        ebs_baseline_IOPS: "",
        ebs_burst_IOPS: "",
        "backup_style" : "null",
        "ebs_backup_type" : "null",
        "ebs_backup_size" : "null",
        "ebs_backup_iops" : "",
        ebs_backup_snap_size: "",
        ebs_backup_summaryText1: "",
        ebs_backup_summaryText2: "",
        ebs_backup_cost: "",
        license_summaryText: "",
        comments: "",
        iomb_warnings: "",
        cpu_warnings: "",
        iops_warnings: "",
        UseMAZ: "No",
        UseSE2: "No"
      };



      tempConfig.shape = ec2ItemSelected.Name;
      tempConfig.shape_OD = ec2ItemSelected.LinuxOD;
      tempConfig.shape_RI = ec2ItemSelected.Linux1yrNURI;
      tempConfig.shape_max_vcpu = ec2ItemSelected.VCPU;
      tempConfig.shape_optimize_vcpu = ec2ItemSelected.VCPU;
      tempConfig.requested_vcpu = config.VCPU;
      tempConfig.requested_memory = config.Memory;
      tempConfig.shape_memory = ec2ItemSelected.Memory;
      tempConfig.requested_throughput = config.Throughput;
      tempConfig.shape_throughput = ec2ItemSelected.Throughput;
      tempConfig.shape_baselinethroughput = ec2ItemSelected.BaselineThroughput;
      tempConfig.shape_baselineIOPS= ec2ItemSelected.BaselineIOPS;        
      tempConfig.shape_IOPS= ec2ItemSelected.IOPS;        
      tempConfig.ebs_data_type = config.VolumeType;
      tempConfig.ebs_data_size = config.DiskSpace;
      
      tempConfig.UseMAZ = config.UseMAZ;
      tempConfig.UseSE2 = "No";

    
      
      if (typeof tempConfig.comments === "undefined") {
        tempConfig.comments = "";
      }

      if (1 * tempConfig.requested_vcpu > 1 * tempConfig.shape_max_vcpu) {
        tempConfig.cpu_warnings =
          tempConfig.cpu_warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_vcpu +
          " VCPUs. ";
      }
      if (1 * tempConfig.requested_memory > 1 * tempConfig.shape_memory) {
        tempConfig.cpu_warnings =
          tempConfig.cpu_warnings +
          "The shape " +
          tempConfig.shape +
          " does not have " +
          tempConfig.requested_memory +
          " GB of memory. ";
      }
      if (1 * tempConfig.requested_throughput >
        1 * tempConfig.shape_throughput
      ) {
        tempConfig.iomb_warnings =
          tempConfig.iomb_warnings +
          "The shape " +
          tempConfig.shape +
          " does not support " +
          tempConfig.requested_throughput +
          " MB/s of IO throughput. ";
      } else {
        if  (1 * tempConfig.shape_baselinethroughput > 0   && (
          1 * tempConfig.requested_throughput >
          1 * tempConfig.shape_baselinethroughput)
        ) 
        {
          tempConfig.iomb_warnings =
            tempConfig.iomb_warnings +
            "The shape " +
            tempConfig.shape +
            " can burst for short periods to the requested " +
            tempConfig.requested_throughput +
            " MB/s of IO throughput, but has a baseline throughput of " + tempConfig.shape_baselinethroughput + " MB/s. ";
        }
      }  
      

      //optimizeVCPU calculation
          if (!((config.optgoal_choice=="min_license") || (config.optgoal_choice=="min_cost") )) {
      // does this shape offer optimizeVCPU?
      if ((typeof ec2ItemSelected.OptimizeVCPUs != "undefined")&&(ec2ItemSelected.OptimizeVCPUs != null)) {
        //find the closest match...

        var choices = ec2ItemSelected.OptimizeVCPUs.split(",");
        for (var ov = 0; ov < choices.length; ov++) {
          //   console.log("optimizeVCPU debug1:"+tempConfig.requested_vcpu+" "+choices[ov]);
          if (1 * choices[ov] >= tempConfig.requested_vcpu * 1) {
            tempConfig.shape_optimize_vcpu = choices[ov];
            if (tempConfig.shape_optimize_vcpu*1 < tempConfig.requested_vcpu * 1) {
              tempConfig.cpu_warnings = tempConfig.cpu_warnings + "Optimize CPU feature considered for licensing benefits. ";
            }  
            // console.log("Using optimizevcpu"+choices[ov])
            break;
          }
        }
      }
          } else {
            tempConfig.shape_optimize_vcpu = tempConfig.shape_max_vcpu;
          }
      
      var shapeCost = 0;
      var RIused = "OD";

      //licenseText

              tempConfig.license_summaryText =
                "Oracle BYOL for " +
                tempConfig.shape_optimize_vcpu +
                " VCPUs ";
              if (tempConfig.UseMAZ=="Yes") {
                tempConfig.license_summaryText +=
                "per node (" + 1 * tempConfig.shape_optimize_vcpu +
                " Oracle Processor Licenses total - accounts for licensing both nodes of 2-nodeHA)";
              } else {
                tempConfig.license_summaryText +=
                "("+ 0.5 * tempConfig.shape_optimize_vcpu +
                " Oracle Processor Licenses)";
              }  
        
              if (1 * tempConfig.shape_max_vcpu - tempConfig.shape_optimize_vcpu > 0) {
                tempConfig.license_summaryText =
                  tempConfig.license_summaryText +
                  ".  Optimize CPU feature used to go from " +
                  tempConfig.shape_max_vcpu +
                  " to " +
                  tempConfig.shape_optimize_vcpu +
                  " VCPUs.";
              }
        
              if ((config.optgoal_choice=="Y")&&(1 * tempConfig.shape_optimize_vcpu - tempConfig.requested_vcpu > 4)) {
                    tempConfig.cpu_warnings =
                      tempConfig.cpu_warnings +
                      "This shape does not appear to offer the Optimize CPU feature. ";
              }


          var temp_UseRI = config.UseRI;
        
           // ignore Savings Plans for Elasticache for now
           if ( (temp_UseRI=="SP-Only") || (temp_UseRI=="RI+SP") || (temp_UseRI=="SP") ) {
             temp_UseRI="RI";
           }

              if (tempConfig.UseMAZ=="Yes") {
                
                if ((temp_UseRI=='RI') && tempConfig.shape_RI > 0) {
                  shapeCost = ec2ItemSelected.Linux1yrNURI * 730 *2;
                  tempConfig.shape_summaryText =
                    "EC2 Compute Monthly estimate using 2-nodeHA (using 1-year standard Reserved Instance pricing): $" +
                    shapeCost.toFixed(2);
                    RIused="RI";
                } else {
                  shapeCost = ec2ItemSelected.LinuxOD * 730 *2;
          
                  tempConfig.shape_summaryText =
                    "EC2 Compute Monthly estimate using 2-nodeHA (using On-Demand pricing): $" +
                    shapeCost.toFixed(2);
                }
                
               } else {
                if ((temp_UseRI=='RI') && tempConfig.shape_RI > 0) {
                  shapeCost = ec2ItemSelected.Linux1yrNURI * 730;
                  tempConfig.shape_summaryText =
                    "EC2 Compute Monthly estimate (using 1-year standard Reserved Instance pricing): $" +
                    shapeCost.toFixed(2);
                    RIused="RI";
                } else {
                  shapeCost = ec2ItemSelected.LinuxOD * 730;
          
                  tempConfig.shape_summaryText =
                    "EC2 Compute Monthly estimate (using On-Demand pricing): $" +
                    shapeCost.toFixed(2);
                }
              }
              tempConfig.shape_cost = shapeCost;

              var tempCost=0.0;
              var mazString = "";
              var mazFactor = 1.0;
              if (tempConfig.UseMAZ=="Yes") {
                mazString=" using 2-nodeHA";
                mazFactor = 2.0;
              }

              
      // tempConfig.shape_summaryText =
      //   "EC2 Compute Monthly estimate"+mazString+" (using 1-year standard Reserved Instance pricing): $" +
      //   (ec2ItemSelected.Linux1yrNURI * 730* mazFactor).toFixed(2);
      // tempConfig.shape_cost=(ec2ItemSelected.Linux1yrNURI * 730* mazFactor);

      var tempString = "EC2 Monthly"+mazString+ " = ";
      
      
      if (config.VolumeType == "io1") {
        // io1
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          config.DiskSpace +
          " GB of io1 (Provisioned IOPS SSD) at " +
          config.IOPS +
          " IOPS.";

        tempConfig.ebs_data_iops = config.IOPS;
        tempConfig.ebs_data_cost = (config.DiskSpace * regionInfo.ec2_io1_gb * mazFactor) +(regionInfo.ec2_io1_iops * config.IOPS* mazFactor);
        tempConfig.ebs_data_summaryText2 =
          "EBS Storage"+mazString+" Monthly estimate: EBS Volumes=$" +
          (tempConfig.ebs_data_cost).toFixed(2) + " [Storage=$"+
          (config.DiskSpace * regionInfo.ec2_io1_gb * mazFactor).toFixed(2) +
          ", IOPS=$" +
          (regionInfo.ec2_io1_iops * config.IOPS* mazFactor).toFixed(2) + "] " ;

        tempString =
          tempString +
          "[" +
          ec2ItemSelected.Name +
          "] + EBS(DATA)=[" +
          config.VolumeType +
          " @ " +
          config.DiskSpace +
          " GB @ " +
          config.IOPS +
          " IOPS]";
        tempCost =
          1 * tempCost +
          (shapeCost +
            config.DiskSpace * regionInfo.ec2_io1_gb * mazFactor +
            regionInfo.ec2_io1_iops * config.IOPS* mazFactor);
      } else if (config.VolumeType == "io2") {
        //io2
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          config.DiskSpace +
          " GB of io2 (Provisioned IOPS SSD) at " +
          config.IOPS +
          " IOPS.";
          
        //assumption: instead of provisioning 1 volume at N IOPS, we provision 4 volumes at N/4 IOPS.
        
        var iopsCost=0.0;
        var tempIOPS = config.IOPS / 4;
        
        if (tempIOPS<=32000) {
          iopsCost=tempIOPS*regionInfo.ec2_io2_iops1* mazFactor;
        } else {
          iopsCost=32000*regionInfo.ec2_io2_iops1* mazFactor;
          if (tempIOPS<=64000) {
            iopsCost=32000*regionInfo.ec2_io2_iops1* mazFactor + (tempIOPS-32000)*regionInfo.ec2_io2_iops2* mazFactor;
          } else {
            iopsCost=32000*regionInfo.ec2_io2_iops1* mazFactor + 32000*regionInfo.ec2_io2_iops2 * mazFactor+ (tempIOPS-64000)*regionInfo.ec2_io2_iops3* mazFactor;
          }
        }
        iopsCost = iopsCost*4; //add up IOPS costs for all 4 volumes
        if (config.IOPS*1>128000) {
          //add message that we are using 4 volumes to calculate pricing
          tempConfig.ebs_data_summaryText1 += " (Assuming 4 io2 volumes, each with "+config.IOPS/4+ " IOPS)";
        }

        tempConfig.ebs_data_iops = config.IOPS;
        tempConfig.ebs_data_cost = (config.DiskSpace * regionInfo.ec2_io2_gb* mazFactor) +iopsCost;

        tempConfig.ebs_data_summaryText2 =
          "EBS Storage"+mazString+" Monthly estimate: EBS Volumes=$" +
          (tempConfig.ebs_data_cost).toFixed(2) + " [Storage=$"+
          (config.DiskSpace * regionInfo.ec2_io2_gb* mazFactor).toFixed(2) +
          ", IOPS=$" +
          (iopsCost).toFixed(2) + "] " ;


        tempString =
          tempString +
          "[" +
          ec2ItemSelected.Name +
          "] + EBS(DATA)=[" +
          config.VolumeType +
          " @ " +
          config.DiskSpace +
          " GB @ " +
          config.IOPS +
          " IOPS]";
        tempCost =
          1 * tempCost +
          (shapeCost +
            tempConfig.ebs_data_cost);

        if (1 * config.IOPS > 256000) {
          tempConfig.iops_warnings =
            tempConfig.iops_warnings +
            "This tool may not compute prices accurately when specifying over 256000 IOPS. ";
        }
        if (1 * config.IOPS > 500 * config.DiskSpace) {
          tempConfig.iops_warnings =
            tempConfig.iops_warnings +
            "io2 can support up to 500 IOPS per GB, which for your disk storage size would be " +
            config.DiskSpace * 500 +
            ".  This is less than your desired " +
            config.IOPS +
            " IOPS. ";
        }
        
        //if this blockexpress, ensure that we only use r5b, x2idn, or x2iedn
        
        //other things to check?
        //io2 volume max is 16TB.  io2 block express max is 64TB
        //io2 block express can do 1000 IOPS/GB (more than 500)
        
            
      } else if (config.VolumeType == "gp3") {
        //gp3
        
        //For now, we assume 1 gp3 volume.  (meaning you only get 1 volume worth of IOPS and Throughput credits)
        
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          config.DiskSpace +
          " GB of gp3 (General Purpose SSD) at " +
          config.IOPS +
          " IOPS and " +
          tempConfig.requested_throughput +
          " MB/s. ";
        var iopsCost=0.0;
        if (config.IOPS*1>3000) {
          iopsCost=(config.IOPS-3000)*regionInfo.ec2_gp3_iops* mazFactor;
        } 

        var mbsCost=0.0;
        if (tempConfig.requested_throughput*1>125) {
          mbsCost=(tempConfig.requested_throughput-125)*regionInfo.ec2_gp3_thru/1024* mazFactor; 
        } 
        
        tempConfig.ebs_data_iops = config.IOPS;
        tempConfig.ebs_data_throughput = tempConfig.requested_throughput;
        tempConfig.ebs_data_cost = (config.DiskSpace * regionInfo.ec2_gp3_gb* mazFactor) +iopsCost + mbsCost;

        tempConfig.ebs_data_summaryText2 =
          "EBS Storage"+mazString+" Monthly estimate: EBS Volumes=$" +
          (tempConfig.ebs_data_cost).toFixed(2) + " [Storage=$"+
          (config.DiskSpace * regionInfo.ec2_gp3_gb* mazFactor).toFixed(2) +
          ", IOPS=$" +
          (iopsCost).toFixed(2) +
        ", MB/s=$" +
          (mbsCost).toFixed(2) +"] " ;


        tempString =
          tempString +
          "[" +
          ec2ItemSelected.Name +
          "] + EBS(DATA)=[" +
          config.VolumeType +
          " @ " +
          config.DiskSpace +
          " GB @ " +
          config.IOPS +
          " IOPS @ "+
          tempConfig.requested_throughput +
          " MB/s]";
        tempCost =
          1 * tempCost +
          (shapeCost +
            tempConfig.ebs_data_cost);

        if (1 * config.IOPS > 500 * config.DiskSpace) {
          tempConfig.iops_warnings =
            tempConfig.iops_warnings +
            "gp3 can support up to 500 IOPS per GB, which for your disk storage size would be " +
            config.DiskSpace * 500 +
            ".  This is less than your desired " +
            config.IOPS +
            " IOPS. ";
        }
        
        tempConfig.iops_warnings  = tempConfig.iops_warnings + "EC2 gp3 pricing assumes only 1 volume worth of IOPS (3000) and Throughput (125 MB/s) baseline. ";
        //other things to check?
        
      } else {  
        //gp2
        tempConfig.ebs_data_summaryText1 =
          "EBS Volume Type (DATA): " +
          config.DiskSpace +
          " GB of gp2 (General Purpose SSD)";
        tempConfig.ebs_data_summaryText2 =
          "EBS Storage"+mazString+" Monthly estimate: EBS Volumes=$" +
          (config.DiskSpace * regionInfo.ec2_gp2_gb* mazFactor).toFixed(2);

        tempConfig.ebs_data_cost = (config.DiskSpace * regionInfo.ec2_gp2_gb* mazFactor) ;
  

        if (1 * config.IOPS > 3 * config.DiskSpace + 2) {
          tempConfig.iops_warnings =
            tempConfig.iops_warnings +
            "Calculated gp2 baseline IOPS of " +
            config.DiskSpace * 3 +
            " is less than your desired " +
            config.IOPS +
            " IOPS (please confirm that the gp2 bursting profile fits your workload). ";
        }
        // https://aws.amazon.com/blogs/database/understanding-burst-vs-baseline-performance-with-amazon-rds-and-gp2/

        tempString =
          tempString +
          "[" +
          ec2ItemSelected.Name +
          "] + EBS(DATA)=[" +
          config.VolumeType +
          " @ " +
          config.DiskSpace +
          " GB]";
        tempCost =
          1 * tempCost +
          (shapeCost + config.DiskSpace * regionInfo.ec2_gp2_gb* mazFactor);
      }

      //backup style
      var snapshotSize = 0;
      if (
        config.BackupType == "datasnap" ||
        config.BackupType == "frasnap"
      ) {
        // assume 0.7 for database backup compression: skip null blocks
        snapshotSize =
          ((config.Backup * 60 * 60 * 24) / 1024) * config.SnapshotDays +
          config.DiskSpace * 0.7;
      }

      if (config.BackupType == "fra") {
        tempConfig.ebs_backup_size = 1.25 * config.DiskSpace;
        tempConfig.ebs_backup_cost=tempConfig.ebs_backup_size * regionInfo.ec2_gp2_gb;
        tempCost = tempCost + tempConfig.ebs_backup_cost;
        

        tempConfig.ebs_backup_summaryText1 =
          "EBS Volume Type (Flash Recovery Area): " +
          tempConfig.ebs_backup_size +
          " GB of gp2 (General Purpose SSD)";
        tempConfig.ebs_backup_summaryText2 =
          "Monthly estimate (FRA): EBS Volumes=$" + tempConfig.ebs_backup_cost.toFixed(2);
        
        tempString =
          tempString +
          " + EBS(FRA)=[gp2 @ " +
          config.DiskSpace * 1.25 +
          " GB]";
      }
      if (config.BackupType == "datasnap") {
        tempConfig.ebs_backup_snap_size = snapshotSize;
        tempConfig.ebs_backup_cost=0.05 * snapshotSize;
        tempCost = tempCost + tempConfig.ebs_backup_cost;

        tempConfig.ebs_backup_summaryText1 =
          "EBS Snapshots (DATA): estimated " +
          tempConfig.ebs_backup_snap_size.toFixed(0) +
          " GB of Snapshots";
        tempConfig.ebs_backup_summaryText2 =
          "Monthly estimate (Snapshots of DATA): EBS Snapshots=$" +
          tempConfig.ebs_backup_cost.toFixed(2);
        

        tempString =
          tempString +
          " + Snapshots(DATA)=[" +
          snapshotSize.toFixed(0) +
          " GB of Snapshots]";
      }
      if (config.BackupType == "frasnap") {
        tempConfig.ebs_backup_size = 1.25 * config.DiskSpace;
        tempConfig.ebs_backup_snap_size = snapshotSize;
        tempCost =
          tempCost + 1.25 * config.DiskSpace * regionInfo.ec2_gp2_gb + 0.05 * snapshotSize;

        tempConfig.ebs_backup_summaryText1 =
          "EBS Volume Type (Flash Recovery Area): " +
          tempConfig.ebs_backup_size +
          " GB of gp2 (General Purpose SSD) with estimated " +
          tempConfig.ebs_backup_snap_size.toFixed(0) +
          " GB of Snapshots";
        tempConfig.ebs_backup_summaryText2 =
          "Monthly estimate (FRA): EBS Volumes=$" +
          (tempConfig.ebs_backup_size * regionInfo.ec2_gp2_gb).toFixed(2) +
          ", EBS Snapshots=$" +
          (0.05 * tempConfig.ebs_backup_snap_size).toFixed(2);

        tempConfig.ebs_backup_cost=1.25 * config.DiskSpace * regionInfo.ec2_gp2_gb + 0.05 * snapshotSize;

        tempString =
          tempString +
          " + EBS(FRA)=[gp2 @ " +
          config.DiskSpace * 1.25 +
          " GB with " +
          snapshotSize.toFixed(0) +
          " GB of Snapshots]";
      }
      tempConfig.summaryText =
        tempString +
        "=$" +
        tempCost.toFixed(2) +
        " + " +
        0.5 * tempConfig.shape_optimize_vcpu*mazFactor +
        " Oracle Processor Licenses + Self Management";

      tempConfig.monthly_estimate   = Math.round(tempCost*100)/100;
      tempConfig.RIused = RIused;



        
        
        // now finish up matchConfig stuff        
        config.ec2_shape = tempConfig.shape;
        config.targetconfig_ec2 = tempConfig;
        config.targetconfig_ec2.closeness_string = ec2ItemSelected.closeness_string;
        config.targetconfig_ec2.match_string = ec2ItemSelected.match_string;

        
        if (tempConfig.iomb_warnings != "") {
            config.iomb_warnings = "Y";
        } else {
          config.iomb_warnings = "";
        }
        if (tempConfig.iops_warnings != "") {
            config.iops_warnings = "Y";
        } else {
          config.iops_warnings = "";
        }

      }


      return config;
    }





export {pick_ec2_shape};
export {calculate_ec2_config};
